module.exports = __webpack_public_path__ + "media/packs/images/flags/CV-81868c85f970c9201ff5d1e8a8da4da4.svg";